import {useQuery} from 'react-query';
import type {UploadedFile} from './FileUploaderFileListItem';
import type {StripeFileFragmentData} from './stripeFileFragment';
import useRetrieveFileLazyQuery from './useRetrieveFileLazyQuery';

export const RETRIEVE_FILE_KEY = 'retrieve-file';

export const useRetrieveFile = (
  uploadedFile: UploadedFile,
  onFileSuccessfullyUploaded: (
    fileId: string,
    stripeFile: StripeFileFragmentData,
  ) => void,
) => {
  const {localFile, stripeFile} = uploadedFile;
  const [retrieveFile] = useRetrieveFileLazyQuery({
    expectedErrors: ['resource_missing'],
  });

  return useQuery<StripeFileFragmentData | undefined, Error>(
    [RETRIEVE_FILE_KEY, uploadedFile.id],
    async () => {
      if (stripeFile || localFile) {
        return undefined;
      }

      const {data} = await retrieveFile({
        variables: {
          fileId: uploadedFile.id,
        },
      });

      return data?.v1FilesFile || undefined;
    },
    {
      onSuccess: (stripeFile) => {
        if (stripeFile) {
          onFileSuccessfullyUploaded(uploadedFile.id, stripeFile);
        }
      },
    },
  );
};
